import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import BaseSelect from "components/baseSelect";

const FormikPhone = ({
  errors,
  touched,
  handleChange,
  values,
  element,
  removePhoneNumber,
  options,
  InputMask,
  index,
}) => {
  const onRemovePhoneNumber = () => removePhoneNumber(element.id);

  const alignEnd = {
    display: "flex",
    alignItems: "flex-end",
  };

  const alignCenter = {
    display: "flex",
    alignItems: "center",
  };

  return (
    <>
      <BaseSelect
        md={3}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        values={values}
        label={"Tipo *"}
        name={`phoneType_${element.id}`}
        url={"TelefonoTipo"}
      />

      <Form.Group as={Col} md="3" controlId={"validationFormik_" + element.id}>
        <Form.Label> Número de teléfono *</Form.Label>
        <Form.Control
          as={InputMask}
          mask="(999) 999-9999"
          type="text"
          name={`phoneNumber_${element.id}`}
          placeholder="(829) 000-0000"
          value={values[`phoneNumber_${element.id}`]}
          onChange={handleChange}
          //isValid={touched[`phoneNumber_${element.id}`] && !errors[`phoneNumber_${element.id}`]}
          isInvalid={!!errors[`phoneNumber_${element.id}`]}
        />
        <Form.Control.Feedback type="invalid">
          {errors[`phoneNumber_${element.id}`]}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group
        as={Col}
        md="6"
        style={!!errors[`phoneNumber_${element.id}`] ? alignCenter : alignEnd}
      >
        {index != 0 && (
          <Button onClick={onRemovePhoneNumber} variant="outline-primary">
            <i className="fas fa-trash-alt"></i>
          </Button>
        )}
      </Form.Group>
    </>
  );
};

export default FormikPhone;
